import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import DeleteIcon from '@material-ui/icons/Delete';
import { useCallback } from 'react';
import { Field } from 'react-final-form';
import { Element } from 'react-scroll';
import { propBool, propFunc, propNumber, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { useKanaEffect, useKanaRef, } from '../../../../../../../helpers/use/useKana';
import SeminarOneFormEmailField from './SeminarOneFormEmailField';
import SeminarOneFormNameField from './SeminarOneFormNameField';
const SeminarOneFormLiaisonsFieldArrayInner = (props) => {
    const { change, className, disabled, fields: { length, remove }, index, name, validates, } = props;
    const kanaRef = useKanaRef();
    const lastNameSelector = `liaisons_${index}_lastName`;
    const firstNameSelector = `liaisons_${index}_firstName`;
    /**
     * 問合せ窓口削除クリック時のイベント
     * @type {(function())|*}
     */
    const onClickDelete = useCallback(() => {
        remove(index);
    }, [remove, index]);
    /**
     *
     * @type {(function(): void)|*}
     */
    const onBlurLastName = useCallback(() => {
        change(`${name}.lastNameKana`, kanaRef.current.last.getFurigana() || '');
    }, [change, kanaRef, name]);
    const onBlurFirstName = useCallback(() => {
        change(`${name}.firstNameKana`, kanaRef.current.first.getFurigana() || '');
    }, [change, kanaRef, name]);
    useKanaEffect(kanaRef, `#${lastNameSelector}`, `#${firstNameSelector}`);
    return (_jsx(Element, Object.assign({ className: className, name: `${name}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_liaisons_inner' }, { children: [_jsxs("div", Object.assign({ className: 'liaisons_left' }, { children: [_jsxs("div", Object.assign({ className: 'row_names' }, { children: [_jsx(Field, { className: 'column_last_name', component: SeminarOneFormNameField, disabled: disabled, id: lastNameSelector, inputClassName: 'name_field', name: `${name}.lastName`, onBlur: onBlurLastName, title: '姓', type: 'text', validate: validates.lastName }), _jsx(Field, { className: 'column_first_name', component: SeminarOneFormNameField, disabled: disabled, id: firstNameSelector, inputClassName: 'name_field', name: `${name}.firstName`, onBlur: onBlurFirstName, title: '名', type: 'text', validate: validates.firstName })] })), _jsx("div", Object.assign({ className: 'row_email' }, { children: _jsx(Field, { className: 'column_email', component: SeminarOneFormEmailField, disabled: disabled, inputClassName: 'email_field', name: `${name}.email`, type: 'email', validate: validates.email }) }))] })), length > 1 && (_jsx("div", Object.assign({ className: 'liaisons_right' }, { children: _jsx("button", Object.assign({ className: 'liaisons_delete', disabled: disabled, onClick: onClickDelete, type: 'button' }, { children: _jsx(DeleteIcon, { className: 'delete_svg' }) })) })))] })) })));
};
SeminarOneFormLiaisonsFieldArrayInner.propTypes = {
    change: propFunc().isRequired,
    className: propStr(),
    disabled: propBool(),
    fields: propShape().isRequired,
    index: propNumber().isRequired,
    name: propStr().isRequired,
    validates: propShape().isRequired,
};
SeminarOneFormLiaisonsFieldArrayInner.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormLiaisonsFieldArrayInner;
